// ローディングスピナーコンポーネント

// React 18以降はJSXの自動変換によりReactインポートは不要

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export function LoadingSpinner({
  message = '読み込み中...',
  size = 'medium',
  className = '',
}: LoadingSpinnerProps) {
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'h-4 w-4';
      case 'large':
        return 'h-12 w-12';
      default:
        return 'h-8 w-8';
    }
  };

  const getTextSize = () => {
    switch (size) {
      case 'small':
        return 'text-sm';
      case 'large':
        return 'text-lg';
      default:
        return 'text-base';
    }
  };

  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      {/* スピナー */}
      <div className="relative">
        <svg
          className={`animate-spin ${getSizeClasses()} text-blue-600`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </div>

      {/* メッセージ */}
      {message && (
        <p className={`mt-4 text-gray-600 font-medium ${getTextSize()}`}>
          {message}
        </p>
      )}
    </div>
  );
}

/**
 * インライン用の小さなローディングスピナー
 */
export function InlineLoadingSpinner({
  className = '',
}: {
  className?: string;
}) {
  return (
    <svg
      className={`animate-spin h-4 w-4 text-current ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

/**
 * ページ全体を覆うローディングオーバーレイ
 */
export function LoadingOverlay({
  message = '処理中...',
  isVisible = true,
}: {
  message?: string;
  isVisible?: boolean;
}) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-25 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-sm mx-4">
        <LoadingSpinner message={message} size="large" />
      </div>
    </div>
  );
}